import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
  DatePicker
} from "antd";
import moment from "moment";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath"; // Import apiPath
import Main from "../../components/layout/Main";
import useDebounce from "../../hooks/useDebounce";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import lang from "../../helper/lang";
const { TextArea } = Input;
const Search = Input.Search;
const { Option } = Select;

function PushNotification() {
  const { request } = useRequest()
  const [searchText, setSearchText] = useState('');
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [list, setList] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false);
  const debouncedSearchText = useDebounce(searchText, 300);
  const [selected, setSelected] = useState();
  const [filter, setFilter] = useState({ startDate: null, endDate: null });


  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    // {
    //   title: "User Type",
    //   dataIndex: "userType",
    //   key: "userType",
    // },
    {
      title: "Notification Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "User",
      render: (_, { user = [], allUser, userType }) => {
        if (allUser || !user || user.length === 0) {
          return <div>All Users</div>;
        }
        return <div>{user.map(obj => obj.name).join(", ")}</div>;
      },
    },
    {
      title: "Registartion date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {

        return (
          new Date(created_at).toLocaleDateString()
        );
        // { isActive ? "Active" : "Inactive" }

      },
    },
    // {
    //   title: "Action",
    //   render: (_, record) => {
    //     return (
    //       <Button className="tb-view" onClick={(e) => { window.location.assign(`/view-notification/${record._id}`) }
    //       }>
    //         <i class="fa fa-light fa-eye"></i>
    //         View
    //       </Button >
    //     )
    //   }
    // }
  ];

  const onSearch = (e) => {
    setSearchText(e.target.value)
    setPagination({ current: 1 })
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : null;
  
    request({
      url: `${apiPath.notification}/list?status=${""}&page=${pagination.current}&pageSize=${pagination.total}&search=${debouncedSearchText}&start_date=${filter?.startDate || ""}&end_date=${filter?.endDate || ""}`,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false);
        console.log(data);
  
        // Flatten notificationsByDate into a single array
        // const notifications = data?.data?.notificationsByDate?.flatMap(group => 
        //   group.notifications.map(notification => ({
        //     ...notification,
        //     createdAt: group.date, // Assign the date from the group
        //   }))
        // ) || [];
      // Extract notifications from response
          const notifications = data?.data?.docs;

  
        setList(notifications); // Now `list` is properly formatted
  
        setPagination(prev => ({
          current: pagination?.current || 1,
          total: data?.data?.total || 0,  
        }));
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      }
    });
  };


  const handleChange = (pagination, filters) => {
    console.log(pagination, filters);
    fetchData(pagination, filters);
  }

  useEffect(() => {
    setLoading(true)
    fetchData(pagination)
  }, [refresh, debouncedSearchText,filter])

  return (
    <div className="tabled">
      <Row>
        <Col xs="24" md={24} lg={24} xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Push Notifications"
            extra={
              <>
                <Search
                  size="large"
                  placeholder="Search by Title, Type"
                  onChange={onSearch}
                  value={searchText}
                  onPressEnter={onSearch}
                />
                
                <div className="role-wrap">
                      <DatePicker.RangePicker
                        disabledDate={(current) => {
                          return current && current > moment().endOf("day");
                        }}
                        placeholder={[lang("Start Date"), lang("End Date")]}
                        value={[
                          filter?.startDate
                            ? moment(filter?.startDate)
                            : undefined,
                          filter?.endDate ? moment(filter?.endDate) : undefined,
                        ]}
                        onChange={(value) => {
                          if (value) {
                            setFilter((prev) => ({
                              ...prev,
                              startDate: moment(value[0]).format("YYYY-MM-DD"),
                              endDate: moment(value[1]).format("YYYY-MM-DD"),
                            }));
                          } else {
                            setFilter((prev) => ({
                              ...prev,
                              startDate: undefined,
                              endDate: undefined,
                            }));
                          }
                        }}
                      />
                  </div>
                <Button onClick={() => setVisible(true)}>Add Notification</Button>
              </>
            }
          >
            <div className="table-responsive">
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                pagination={pagination}
                onChange={handleChange}
                className="ant-border-space"
              />
            </div>
          </Card>
        </Col>
      </Row>
      {visible && <AddFrom show={visible} hide={() => { setSelected(); setVisible(false) }} data={selected} refresh={() => setRefresh(prev => !prev)} />}
    </div>
  );
}

const AddFrom = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest()
  const [loading, setLoading] = useState(false)
  const [selectType, setSelectType] = useState("all");
  const [selectUser, setSelectUser] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [userList, setUserList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);


  const handleSelectAll = (e) => {
    const allUserIds = userList.map((user) => user._id);
    setSelectUser(e.target.checked ? allUserIds : []);
    setSelectAll(e.target.checked);
  };

  const handleTypeChange = (value) => {
    setSelectType(value);
    getList(value)
    setSelectUser([]);
    setLoading(false)
  };

  const handleUserChange = (value) => {
    setSelectUser(value);
    setSelectAll(value.length === userList.length);
  };

  const getList = (type) => {
    setLoading(true);
    request({
      url: `/common/${type}`,
      method: 'GET',
      onSuccess: (data) => {
        setUserList(data.data.data)
      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  };

  const onCreate = (values) => {
    setLoading(true)
    const { title, message, type, notificationtype } = values
    const payload = {}
    payload.title = title
    payload.type = type
    payload.message = message
    payload.userType = selectType ? selectType : "all"
    payload.selectUser = selectUser.length > 0 ? selectUser : []
    payload.allUser = selectAll
    payload.notificationtype = notificationtype
    request({
      url: `${data ? `/admin/notification/edit-notification/${data._id}` : `/admin/notification/add-notification`}`,
      // url: '/admin/expact/add-expact',
      method: `${data ? 'PUT' : 'POST'}`,
      data: payload,
      onSuccess: (data) => {
        setLoading(false)
        if (data.status) {
          // ShowToast(data.message, Severty.SUCCESS)
          // hide()
          refresh()
          hide()
        } else {
          ShowToast(data.message, Severty.ERROR)

        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR)
        // console.log(error.response.data, "Error")
        setLoading(false)
      },
    })
  };

  useEffect(() => {
    if (!data) return
    form.setFieldsValue({ ...data })
  }, [data])

  return (
    <Modal
      open={show}
      title={`${data ? 'Edit' : 'Create'}`}
      okText="Send Notification"
      onCancel={hide}
      okButtonProps={{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Form.Item
          name="type"
          label="Notification Type"
          rules={[
            { required: true, message: "Please select the Notification Type!" }
          ]}
        >
          <Select className="nottfy-add" placeholder="Select Type">
            <Option value="Updates or changes to platform policies">Updates or changes to platform policies</Option>
            <Option value="Promotional offers or discounts">Promotional offers or discounts</Option>
            <Option value="Important alerts or reminders">Important alerts or reminders</Option>
            <Option value="Feedback requests or surveys">Feedback requests or surveys</Option>
            <Option value="Order status updates">Order status updates</Option>
            <Option value="Payment reminders">Payment reminders</Option>
            <Option value="Service maintenance notifications">Service maintenance notifications</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="User Type"
          name="userType"
          rules={[
            { required: true, message: "Please input the Type!" }
          ]}
        >
          <Select className="nottfy-add" placeholder="Select Type" onChange={handleTypeChange}>
            <Option value="all">ALL</Option>
            <Option value="customer">User</Option>
            {/* <Option value="vendor">Vendor</Option> */}
          </Select>
        </Form.Item>

        {selectType != "all" || selectType === null ?
          <Form.Item
            label={`Select ${selectType}`}
            name="user"
          // rules={[
          //   { required: true, message: "Please input the  !" }
          // ]}
          >
            <Checkbox checked={selectAll} onChange={handleSelectAll}>
              Select All
            </Checkbox>
            {!selectAll ?
              <Select
                placeholder={`Select ${selectType}`}
                mode="multiple"
                className="select-show-inn"

                value={selectUser}
                onChange={handleUserChange}
                filterOption={(input, option) => {
                  console.log(option.props)
                  const inputValue = input.toLowerCase();
                  const optionLabel = option.props.children.toLowerCase();
                  // const [code, phone] = optionLabel.split('-')
                  // console.log(inputValue, optionLabel);

                  return (optionLabel.includes(inputValue))
                }}
              >
                {userList.length > 0 && userList.map((item) =>
                (
                  <Option key={item._id} value={item._id}>
                    {item.name}
                  </Option>
                ))}
              </Select> : null}
          </Form.Item> : null}

        <Form.Item
          label="Title"
          name="title"
          rules={[
            { required: true, message: "Please Enter the  title!" }
          ]}
        >
          <Input  placeholder="Title"/>
          {/* <Input type="textarea" /> */}
        </Form.Item>
        <Col span={24}>
          <Form.Item
            label="Message"
            name="message"
            className="textarea-inn"
            rules={[
              { required: true, message: "Please Enter the  message!" }
            ]}
          >
            <TextArea rows={4} placeholder="Message" />
            {/* <Input type="textarea" /> */}
          </Form.Item>
        </Col>

      </Form>
    </Modal>

  )
}

export default PushNotification;
